import type { PageLoadTimePerformanceEntry } from '@ms-cloudpack/common-types-browser';

export interface TelemetryConfig {
  /**
   * Application Insights connection string.
   */
  connectionString?: string;

  /**
   * Cloudpack will query this performance entry to determine the page load time.
   */
  pageLoadTimePerformanceEntry?: PageLoadTimePerformanceEntry;
}
